module.exports = __webpack_public_path__ + "images/emoji/metal.19a06afa1c2bf8f82f6f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/metal.png
// module id = 0pSV
// module chunks = 14